<template>
  <div class="container top-0 position-sticky z-index-sticky">
    <div class="row">
      <div class="col-12">
        <navbar
          isBlur="blur  border-radius-lg my-3 py-2 start-0 end-0 mx-4 shadow"
          v-bind:darkMode="true"
          isBtn="bg-gradient-success"
        />
      </div>
    </div>
  </div>
  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100"
                style="background-image: url('/img/bg.jpg');
          background-size: cover;">
        <div class="container">
          <div class="row">
            <div class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0">
              <div class="card card-plain">
                <div class="pb-0 card-header text-start" hidden>
                  <h4 class="font-weight-bolder"></h4> 
                  <p class="mb-0"></p>
                  <ul>
                    <li>
                    
                    </li>
                  </ul>
                </div>
                <div class="px-1 pt-0 text-center card-footer px-lg-2">
                  <br>
                  <p class="mx-auto mb-4 text-sm">
                    
                  </p>
                </div>
              </div>
            </div>
            <div
              class="top-0 my-auto text-center col-6 d-lg-flex d-none h-100 pe-0 position-absolute end-0 justify-content-center flex-column"
            >
              <div>
                <img src="/img/fym_white.png"/>
                <h4
                  class="mt-5 text-white font-weight-bolder position-relative" hidden
                >TeamFYM</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
  <app-footer />
</template>

<script>
import router from "../router";
import Navbar from "@/examples/PageLayout/Navbar.vue";
import AppFooter from "@/examples/PageLayout/Footer.vue";

const body = document.getElementsByTagName("body")[0];

export default {
  name: "Home",
  data() {
    return {
      showMenu: false,
      logged_in: [],
    }
  },
  methods: {
    async checkAuth() {
      let response = await fetch("/apis/auth");
      this.loggedin = await response.json();

      if(this.loggedin.result==="loggedin") {
        router.push('/dashboard');
      }
      else {
        //router.push('/');
      }
    },
  },
  components: {
    Navbar,
    AppFooter,
  },
  created() {
    this.checkAuth();
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = false;
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-gray-100");
  },
};
</script>
